import React, { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { SubText, TitleH2 } from 'components/Common/Typography'
import Image from 'next/image'

const EcommerceBenefits: FC<{ data }> = ({ data }) => {
  return (
    <section className="ecommerce_benefits position-relative pt-120px pb-120px">
      <Container>
        <Row className="mb-0">
          <Col xl={6}>
            <TitleH2 text={data?.title} className="mb-0 title_md mb-4" />
            {data?.text?.map((t, i) => {
              return (
                <SubText
                  key={i}
                  className="text-light mb-2 pt-2 me-0 me-lg-5 "
                  text={t}
                />
              )
            })}
          </Col>
          <Col xl={6} className="text-center benefits_items_inner mt-4 mt-xl-0">
            <Row>
              {data?.boxBene?.map((b, i, arr) => {
                return (
                  <Col md={4} key={i} className="mb-4">
                    <div className="benefits_item d-flex flex-column justify-content-center align-items-center">
                      <div className="benefits_icon mb-4">
                        <Image
                          src={b.iconimg}
                          alt="benefits"
                          width={50}
                          height={50}
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                        />
                      </div>
                      <h3 className="benefits_item_text fs-xxl-18px fs-xl-16px fs-16px mb-0">
                        {b.Icontitle}
                      </h3>
                    </div>
                  </Col>
                )
              })}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default EcommerceBenefits
